import { certifikatService } from '../services/certifikat.service';
import  Vue  from 'vue';

const state = {
    certifikat: [],
    sezona:null,
    pridelovalecid:null
};

const actions = {
    load({ dispatch,commit },{sezona,pridelovalecid,makeEditable}) {
        dispatch('alert/clear', "",{ root: true });
        commit('setSezona', sezona)
        commit('setPridelovalecID', pridelovalecid)
      return certifikatService.load(sezona,pridelovalecid)
            .then(
                certifikat => {
                  commit('load', certifikat);
                  if(makeEditable)
                  commit('makeEditable') 
                  return certifikat;                   
                } 
                
            );
    },
    loadVse({ dispatch,commit },{sezona}) {
          dispatch('alert/clear', "",{ root: true });
        commit('load');
          commit('setSezona', sezona)
       return  certifikatService.loadAll(sezona)
            .then(
                certifikat => commit('load', certifikat)
                //,
                //error => commit('getLoggedInFailure', error)
            );
    },
     
      isciVse({ dispatch,commit },{isci}) {
          dispatch('alert/clear', "",{ root: true });
          if(isci.length<3) {
               dispatch('alert/error', "Iskalni niz je prekratek!", { root: true });
               return;
          }
           
        commit('load');
        //  commit('setSezona', sezona)
       return  certifikatService.isci(isci)
            .then(
                certifikat => commit('load', certifikat)
                //,
                //error => commit('getLoggedInFailure', error)
            );
    },
       vrniPoId({ dispatch,commit },{id}) {
          dispatch('alert/clear', "",{ root: true });
        commit('load');
        //  commit('setSezona', sezona)
       return  certifikatService.vrniPoId(id)
            .then(
                certifikat => commit('load', certifikat)
                //,
                //error => commit('getLoggedInFailure', error)
            );
    },
     saveCert({ dispatch, commit },{certifikat}){

        console.log(certifikat);
          certifikatService.save(certifikat)
               .then(
                cert => {
                    Vue.set(certifikat,'saved',true);
                    //Vue.set(certifikat,'jeaktivna',1);
                    // Vue.set(state.certifikat,certifikat.veljaven);
                      Vue.set(certifikat,'id',cert.id);

                    //commit("update",item);
                    
                },
                error => {
                    console.log(error);
                    Vue.set(certifikat,'saved',false)
                    //commit("update",item);
                    dispatch('alert/error', "Shranjevanje ni uspelo", { root: true });
                }
                );

     },
    save({ dispatch, commit }) {
     

         console.log("Shranjujem!");
        let sezona=this.state.certifikat.sezona;
        let pridelovalecid=this.state.certifikat.pridelovalecid;
        console.log(this.state);
        dispatch('alert/clear', "",{ root: true });

        this.state.certifikat.certifikat.forEach(item=>{
            item.sezona=sezona;
            item.pridelovalecid=pridelovalecid;
            console.log(item);
            if(item.jeaktivna){
              certifikatService.save(item)
               .then(
                certifikat => {
                    Vue.set(item,'saved',true);
                     Vue.set(item,'jeaktivna',1);
                      Vue.set(item,'id',certifikat.id);
                    //commit("update",item);
                    
                },
                error => {
                    console.log(error);
                    Vue.set(item,'saved',false)
                    //commit("update",item);
                    dispatch('alert/error', "Shranjevanje ni uspelo", { root: true });
                }
            );
            }
            else
             certifikatService.remove(item).then(
                certifikat => {
                 Vue.set(item,'saved',true);
                                      
                },
                error => {
                    console.log(error);
              Vue.set(item,'saved',false);
                  
                    dispatch('alert/error', "Brisanje ni uspelo", { root: true });
                });
            //tukaj naredi ikono, da je shranjvanje uspešno na začetku ali nekje
            //uporabi info, če je prišlo kje do napake!

          });
       
        
    }
};

const mutations = {
  
    load(state, certifikat) {
             if(certifikat&&Array.isArray(certifikat))
        state.certifikat=certifikat.map(k=>{
            k["datumizdaje"]=kendo.parseDate(k["datumizdaje"]) 
            k["datumveljavnosti"]=kendo.parseDate(k["datumveljavnosti"]) 
          
            return k;
        }

            );
            else if(certifikat){
            state.certifikat=certifikat;   
            state.certifikat.datumveljavnosti=kendo.toString(kendo.parseDate(state.certifikat.datumveljavnosti),'d');//kendo.parseDate(state.certifikat.datumveljavnosti); 
            state.certifikat.datumizdaje=kendo.toString(kendo.parseDate(state.certifikat.datumizdaje),'d');
            }
    },
    add(state, item) {
        if(!item.id) {
            //do id
            var minid=state.certifikat.reduce((prev, curr) => prev.id < curr.id ? prev : curr,{id:0}).id;
            if(minid>0)
                minid=0;
            minid--;
            item.id=minid;
        }
        state.certifikat.push(item);
    },
    setSezona(state, item) {
        state.sezona=item;
    },
    makeEditable(state){
        for (var i=0;i<state.certifikat.length;i++){
            let dateStr=state.certifikat[i].datumizdaje;
            if(dateStr)
                state.certifikat[i].datumizdaje=new Date(dateStr);
            else
                state.certifikat[i].datumizdaje=new Date( );

            let dateVeljavnostStr=state.certifikat[i].datumveljavnosti;
            if(dateVeljavnostStr)
                state.certifikat[i].datumveljavnosti=new Date(dateVeljavnostStr);
            else
                state.certifikat[i].datumveljavnosti=new Date( ); //zadnji dan v naslednjem letu

            let updated = Object.assign({}, state.certifikat[i], { inEdit: true });
            state.certifikat.splice(i,1,updated);
        }
        

    },
    setPridelovalecID(state, item) {
        state.pridelovalecid=item;
    },
  
    update(state, item) {
        //state.kultura = kultura;
        //state.kultura;
       
        let updated;
        let itemID = item.id
            let index = state.certifikat.findIndex(p =>
                (JSON.stringify({ ...p }) === JSON.stringify(item) )
                 || itemID && p.id === itemID);
            if (index >= 0) {
                updated = Object.assign({}, item);
                state.certifikat.splice(index,1,updated);
            } else {
                let id = 1;
                state.certifikat.forEach(p => { id = Math.max(p.id + 1, id); });
                updated = Object.assign({}, item, { id: id });
                state.certifikat.unshift(updated);
                index = 0;
            }



        //    return data[index];
        //state.kultura=data;

    },
    remove(state, item) {
        let itemID = item.id
            let index = state.certifikat.findIndex(p =>
                (JSON.stringify({ ...p }) === JSON.stringify(item) )
                 || itemID && p.id === itemID);
                console.log("Brisem!");
                console.log(index);
                console.log(state.certifikat);
                state.certifikat.splice(index, 1);
        
        //    return data[index];
        //state.certifikat=data;

    },
    replace(state, certifikat) {
        state.certifikat = certifikat;
    }
   
};

export const certifikat = {
    namespaced: true,
    state,
    actions,
    mutations
};
